import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { firstValueFrom } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Logger } from '../logger.service';

const log = new Logger('file-service');

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private storage: AngularFireStorage) {}

  uploadFile(file: File, path: string, name: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const filePath = `${path}/${name}`;
      const fileRef = this.storage.ref(filePath);
      const task = this.storage.upload(filePath, file);

      task
        .snapshotChanges()
        .pipe(
          finalize(() => {
            fileRef.getDownloadURL().subscribe(
              (downloadURL) => {
                resolve(downloadURL); // Resuelve la promesa con la URL de descarga
              },
              (error) => {
                reject(error); // Rechaza la promesa si hay un error
              }
            );
          })
        )
        .subscribe({
          error: (error) => {
            reject(error); // Rechaza la promesa en caso de error durante la subida
          },
        });
    });
  }

  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result as string); // Resuelve la promesa con el resultado
      };
      reader.onerror = (error) => {
        reject(error); // Rechaza la promesa en caso de error
      };
      reader.readAsDataURL(file); // Lee el archivo como un Data URL (Base64)
    });
  }

  async getFilesFromPath(path: string) {
    try {
      const ref = this.storage.ref(path);
      const resp = await firstValueFrom(ref.listAll());
      const ret: string[] = [];
      for (let i = 0; i < resp.items.length; i++) {
        const file = resp.items[i];
        const url = await file.getDownloadURL();
        if (url) ret.push(url);
      }
      return ret;
    } catch (error) {
      log.error(error);
      return [];
    }
  }
}
